import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import {EQUIPMENT_SERVICE} from "../EndPoints";
export const SERVICE_ADVANCED_SEARCH = 'advanced-search-service/simple';
export const SERVICE_EQUIPMENT_CURRENTlY_INSIDE = 'equipment-service/v1/currently-inside';
export const SERVICE_EQUIPMENT_NEVER_REGISTERED = 'equipment-service/v1/never-registered';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

//GET: /equipment-service/v1/get-by-id/{id}
export const GetEquipmentDetailsById = createAsyncThunk(
    'equipment/GetEquipmentDetailsById',
    async (params) => {
        const response = await apiInstance
            .get(`${EQUIPMENT_SERVICE.getEquipmentDetailsById}${params}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
//PUT /equipment-service/v1/update
export const UpdateEquipment = createAsyncThunk('equipment/UpdateEquipment', async (params) => {
    const response = await apiInstance
        .put(EQUIPMENT_SERVICE.updateEquipment, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});
// POST: /equipment-service/v1/category/simple/user
export const GetCategoryAndSubcategory = createAsyncThunk(
    'equipment/GetCategoryAndSubcategory',
    async (params) => {
        const response = await apiInstance
            .post(EQUIPMENT_SERVICE.getCategoryAndSubcategory, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = response;
        return { data, status, code };
    },
);
// POST: /equipment-service/v1/category/create
export const CreateCategoryAndSubcategory = createAsyncThunk(
    'equipment/CreateCategoryAndSubcategory',
    async (params) => {
        const response = await apiInstance
            .post(EQUIPMENT_SERVICE.createCategoryAndSubcategory, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = response;
        return { data, status, code };
    },
);

//POST: /equipment-service/v1/create
export const CreateEquipment = createAsyncThunk(
    'equipment/CreateEquipment',
    async (params) => {
        const response = await apiInstance
            .post(`${EQUIPMENT_SERVICE.createEquipment}`, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = response;
        return { data, status, code };
    },
);

///equipment-service/v1/create-asset
export const CreateEquipmentImage = createAsyncThunk(
    'equipment/CreateEquipmentImage',

    async (params, { rejectWithValue }) => {
        try {
            const response = await apiInstance.post(EQUIPMENT_SERVICE.createEquipmentImage, params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    },
);

export const CreateDelivery = createAsyncThunk('equipment/CreateDelivery ', async (params) => {
    const response = await apiInstance
        .post(EQUIPMENT_SERVICE.createDelivery, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status, code } = response;
    return { data, status, code };
});

export const CreateDeliveryAsset = createAsyncThunk(
    'equipment/CreateDeliveryAsset',
    async (params) => {
        const response = await apiInstance
            .post(`${EQUIPMENT_SERVICE.createDeliveryAsset}`, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = response;
        return { data, status, code };
    },
);

export const GetDeliveryById = createAsyncThunk(
    'equipment/GetDeliveryById',
    async (id) => {
        const response = await apiInstance
            .get(`${EQUIPMENT_SERVICE.getDeliveryById}${id}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

//{{base_url}}{{equipment-service}}{{v1}}{{delivery}}{{update}}
export const Updatedelivery = createAsyncThunk('delivery/Updatedelivery', async (params) => {
    const response = await apiInstance
        .put(EQUIPMENT_SERVICE.updatedelivery, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});

// GET {{base_url}}{{equipment-service}}{{v1}}{{tracker}}/get-all-by-delivery-id/35cf9133-6ee7-4b13-8868-189ecf33fb5a
export const GetTrackByDeliveryId = createAsyncThunk(
    'equipment/GetTrackByDeliveryId',
    async (params) => {
        const response = await apiInstance
            .get(`${EQUIPMENT_SERVICE.getTrackByDeliveryId}${params}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
//POST {{base_url}}{{equipment-service}}{{v1}}{{tracker}}{{create}}
export const CreateActivityTracker = createAsyncThunk(
    'equipment/CreateActivityTracker',
    async (params) => {
        const response = await apiInstance
            .post(EQUIPMENT_SERVICE.createActivityTracker, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = response;
        return { data, status, code };
    },
);

export const UploadActivityTracker = createAsyncThunk(
    'equipment/UploadActivityTracker',
    async (params) => {
        const response = await apiInstance
            .post(`${EQUIPMENT_SERVICE.uploadActivityTracker}`, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = response;
        return { data, status, code };
    },
);

export const GetEquipmentList = createAsyncThunk(
    'equipment/GetEquipmentList',
    async (params) => {
        const response = await apiInstance
            .post(EQUIPMENT_SERVICE.getEquipmentList, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = response;
        return { data, status, code };
    },
);

export const EquipmentCheckInOut = createAsyncThunk(
    'equipment/equipmentCheckInOut ',
    async (body) => {
        const response = await apiInstance
            .post(`${EQUIPMENT_SERVICE.equipmentCheckInOut}`, body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = response;
        return { data, status, code };
    },
);


export const GetAccessLogEntryById = createAsyncThunk(
    'equipment/getAccessLogEntryById ',
    async (id) => {

        const response = await apiInstance
            .get(`${EQUIPMENT_SERVICE.getAccessLogEntryById}${id}${EQUIPMENT_SERVICE.checkInLog}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = response;
        return { data, status, code };
    },
);

export const GetAccessLogExitById = createAsyncThunk(
    'equipment/getAccessLogExitById ',
    async (id) => {

        const response = await apiInstance
            .get(`${EQUIPMENT_SERVICE.getAccessLogEntryById}${id}${EQUIPMENT_SERVICE.checkOutLog}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = response;
        return { data, status, code };
    },
);

